export default "__VITE_ASSET__C1iIA8Ms__"